var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAngleLeftDouble = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M223.6,235.6c-12.5,12.5-12.5,32.8,0,45.3l160,160c12.5,12.5,32.8,12.5,45.3,0s12.5-32.8,0-45.3L291.5,258.2 l137.3-137.4c12.5-12.5,12.5-32.8,0-45.3s-32.8-12.5-45.3,0L223.6,235.6L223.6,235.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1,231.2c-12.5,12.5-12.5,32.8,0,45.3l160,160c12.5,12.5,32.8,12.5,45.3,0c12.5-12.5,12.5-32.8,0-45.3 L151,253.8l137.3-137.4c12.5-12.5,12.5-32.8,0-45.3s-32.8-12.5-45.3,0L83.1,231.2L83.1,231.2z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAngleLeftDouble);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/AngleLeftDouble.d884d050132a863e0b2b37649ad26e02.svg";